<template>
    <section>
        <el-form :inline="true" class="toolbar" :model="searchForm">
            <el-form-item label="请求时间">
                <el-date-picker v-model="searchForm.timeRange" type="datetimerange" range-separator="至"
                    start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 360px" />
            </el-form-item>
            <el-form-item label="用户UID">
                <el-input v-model="searchForm.userId" placeholder="请输入" clearable style="width: 150px" />
            </el-form-item>
            <el-form-item label="请求ID">
                <el-input v-model="searchForm.id" placeholder="请输入" clearable style="width: 150px" />
            </el-form-item>
            <el-form-item label="拉单源">
                <el-select clearable v-model="searchForm.orderSource" placeholder="请选择" style="width: 120px">
                    <el-option label="用户" :value="0" />
                    <el-option label="系统" :value="1" />
                </el-select>
            </el-form-item>
            <el-form-item label="商户">
                <el-select clearable v-model="searchForm.merchantId" placeholder="请选择商户" style="width: 180px">
                    <el-option v-for="item in merchantList" :key="item.id" :label="item.merchantName"
                        :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="支付方式">
                <el-select clearable v-model="searchForm.accountType" placeholder="请选择支付方式" style="width: 150px">
                    <el-option v-for="(item, index) in accountTypeOptions" :key="index" :label="item" :value="item" />
                </el-select>
            </el-form-item>
            <el-form-item label="请求状态">
                <el-select clearable v-model="searchForm.status" placeholder="请选择" style="width: 120px">
                    <el-option label="初始化" value="0" />
                    <el-option label="处理中" value="1" />
                    <el-option label="交易成功" value="2" />
                    <el-option label="交易失败" value="3" />
                    <el-option label="回退" value="4" />
                    <el-option label="其他" value="5" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="search" type="primary" size="mini">查询</el-button>
                <el-button @click="handleReset" size="mini">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" border height="650" style="width: 100%" v-loading="loading">
            <el-table-column align="center" prop="id" label="请求ID" width="80"></el-table-column>
            <el-table-column align="center" prop="createTime" label="请求时间" width="160"></el-table-column>
            <el-table-column align="center" prop="userId" label="用户UID" width="100"></el-table-column>
            <el-table-column align="center" prop="orderNo" label="平台订单ID" width="180"></el-table-column>
            <el-table-column align="center" prop="orderSource" label="拉单源" width="80">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.orderSource === 0 ? 'primary' : 'warning'">
                        {{ scope.row.orderSource === 0 ? '用户' : '系统' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="payChannel" label="支付通道" width="120"></el-table-column>
            <el-table-column align="center" prop="accountType" label="支付方式" width="100"></el-table-column>
            <el-table-column align="center" prop="currency" label="货币类型" width="80"></el-table-column>
            <el-table-column align="center" prop="appAccountType" label="商城支付方式" width="120"></el-table-column>
            <el-table-column align="center" prop="amount" label="支付金额" width="100"></el-table-column>
            <el-table-column align="center" prop="status" label="请求状态" width="100">
                <template slot-scope="scope">
                    <el-tag :type="getStatusType(scope.row.status)">
                        {{ getStatusText(scope.row.status) }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="errorMessage" label="错误信息" min-width="150"
                show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="responseMessage" label="请求结果" min-width="200"
                show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="weightScore" label="轮询权重总分" width="100"></el-table-column>
            <el-table-column align="center" prop="weightMessage" label="轮询权重详情" min-width="200"
                show-overflow-tooltip></el-table-column>
        </el-table>

        <el-pagination class="pager" @size-change="pageSizeChange" @current-change="pageIndexChange"
            :current-page="pageIndex" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper" :total="dataTotal"></el-pagination>

        <!-- 详情弹窗 -->
        <el-dialog title="日志详情" :visible.sync="detailVisible" width="700px">
            <el-form label-width="120px" class="detail-form">
                <el-form-item label="请求ID:">
                    <span>{{ detailData.id }}</span>
                </el-form-item>
                <el-form-item label="请求时间:">
                    <span>{{ detailData.createTime }}</span>
                </el-form-item>
                <el-form-item label="用户UID:">
                    <span>{{ detailData.userId }}</span>
                </el-form-item>
                <el-form-item label="平台订单ID:">
                    <span>{{ detailData.orderNo }}</span>
                </el-form-item>
                <el-form-item label="拉单源:">
                    <el-tag :type="detailData.orderSource === 0 ? 'primary' : 'warning'">
                        {{ detailData.orderSource === 0 ? '用户' : '系统' }}
                    </el-tag>
                </el-form-item>
                <el-form-item label="支付通道:">
                    <span>{{ detailData.payChannel }}</span>
                </el-form-item>
                <el-form-item label="支付方式:">
                    <span>{{ detailData.accountType }}</span>
                </el-form-item>
                <el-form-item label="货币类型:">
                    <span>{{ detailData.currency }}</span>
                </el-form-item>
                <el-form-item label="商城支付方式:">
                    <span>{{ detailData.appAccountType }}</span>
                </el-form-item>
                <el-form-item label="支付金额:">
                    <span>{{ detailData.amount }}</span>
                </el-form-item>
                <el-form-item label="请求状态:">
                    <el-tag :type="getStatusType(detailData.status)">
                        {{ getStatusText(detailData.status) }}
                    </el-tag>
                </el-form-item>
                <el-form-item label="错误信息:">
                    <span>{{ detailData.errorMessage || '-' }}</span>
                </el-form-item>
                <el-form-item label="请求结果:">
                    <pre class="json-pre">{{ formatJson(detailData.responseMessage) }}</pre>
                </el-form-item>
                <el-form-item label="轮询权重总分:">
                    <span>{{ detailData.weightScore }}</span>
                </el-form-item>
                <el-form-item label="轮询权重详情:">
                    <span>{{ detailData.weightMessage }}</span>
                </el-form-item>
            </el-form>
        </el-dialog>
    </section>
</template>

<script>
import merchantApi from "@/api/merchantPayConfig/merchantApi";

export default {
    data() {
        return {
            pageIndex: 1,
            pageSize: 20,
            dataTotal: 0,
            loading: false,
            tableData: [],
            searchForm: {
                merchantId: '',
                accountType: '',
                userId: '',
                id: '',
                orderSource: '',
                status: '',
                timeRange: []
            },
            merchantList: [],
            accountTypeOptions: [],
            detailVisible: false,
            detailData: {}
        }
    },
    created() {
        this.getList()
        this.merchantSelect()
    },
    watch: {
        'searchForm.merchantId': {
            handler(newVal) {
                this.searchForm.accountType = ''
                if (newVal) {
                    this.AccountTypeSelect()
                } else {
                    this.accountTypeOptions = []
                }
            },
            immediate: false
        }
    },
    methods: {
        getList() {
            this.loading = true
            const params = {
                content: {
                    merchantId: this.searchForm.merchantId,
                    accountType: this.searchForm.accountType,
                    userId: this.searchForm.userId,
                    id: this.searchForm.id,
                    orderSource: this.searchForm.orderSource,
                    status: this.searchForm.status,
                    pageNo: this.pageIndex,
                    pageSize: this.pageSize
                }
            }
            if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                params.content.startTime = this.searchForm.timeRange[0]
                params.content.endTime = this.searchForm.timeRange[1]
            }
            merchantApi.managePayPollingLogSearch(params).then((res) => {
                if (res.code === '0000') {
                    this.tableData = res.data.rows || []
                    this.dataTotal = res.data.total || 0
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        merchantSelect() {
            merchantApi.getMerchant({}).then((res) => {
                if (res.code === '0000') {
                    this.merchantList = res.data.rows || []
                }
            })
        },
        AccountTypeSelect() {
            merchantApi.getAccountType({ merchantId: this.searchForm.merchantId }).then((res) => {
                if (res.code === '0000') {
                    this.accountTypeOptions = res.data || []
                }
            })
        },
        search() {
            this.pageIndex = 1
            this.getList()
        },
        handleReset() {
            this.searchForm = {
                merchantId: '',
                accountType: '',
                userId: '',
                id: '',
                orderSource: '',
                status: '',
                timeRange: []
            }
            this.pageIndex = 1
            this.getList()
        },
        handleDetail(row) {
            this.detailData = { ...row }
            this.detailVisible = true
        },
        getStatusType(status) {
            const types = ['info', 'warning', 'success', 'danger', 'info', 'info']
            return types[status] || 'info'
        },
        getStatusText(status) {
            const texts = ['初始化', '处理中', '交易成功', '交易失败', '回退', '其他']
            return texts[status] || '未知'
        },
        formatJson(jsonStr) {
            if (!jsonStr) return ''
            try {
                const obj = typeof jsonStr === 'string' ? JSON.parse(jsonStr) : jsonStr
                return JSON.stringify(obj, null, 2)
            } catch (e) {
                return jsonStr
            }
        },
        pageSizeChange(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getList()
        },
        pageIndexChange(val) {
            this.pageIndex = val
            this.getList()
        }
    }
}
</script>

<style lang="scss" scoped>
.pager {
    margin-top: 20px;
    text-align: right;
}

.detail-form {
    .el-form-item {
        margin-bottom: 10px;
    }
}

.json-pre {
    background-color: #f5f7fa;
    padding: 10px;
    border-radius: 4px;
    max-height: 300px;
    overflow: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: monospace;
    font-size: 12px;
    margin: 0;
}
</style>
